import {Box} from '@vio/atlas/helpers/Box'
import {BottomSheet} from '@vio/atlas/src/components/designSystem/BottomSheet'
import {Button} from '@vio/atlas/src/components/designSystem/Button'
import {BottomBar} from '@vio/atlas/src/components/designSystem/helpers/BottomBar'
import {PopUp} from '@vio/atlas/src/components/designSystem/PopUp'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  isOpen: boolean
  handleClose: () => void
}

const Content = () => {
  return (
    <FormattedMessageWrapper
      id="srpFAQs.disclaimerContent"
      defaultMessage="<section><p>This FAQ was generated by OpenAI’s artificial intelligence and may be inaccurate, offensive, or biased. It is not reviewed, so you should not rely on this information without checking its accuracy and reliability yourself.</p><br></br><p>VIO.com is not responsible or liable for the content, quality, accuracy, reliability, or availability of this FAQ.</p></section>"
      values={{
        br: () => <br />,
        section: chunks => <Box className="--section">{chunks}</Box>,
        p: chunks => <Text variant="bodyM">{chunks}</Text>
      }}
    />
  )
}

export const AboutFAQs = ({isOpen, handleClose}: Props) => {
  const {isMobile} = useDeviceLayout()

  if (isMobile) {
    return (
      <BottomSheet
        isOpen={isOpen}
        navBarProps={{
          centerContent: (
            <FormattedMessageWrapper
              id="srpFAQs.disclaimerTitle"
              defaultMessage="About these FAQs"
            />
          )
        }}
        onClose={handleClose}
        noPaddings
        snapPoints={{top: 'nearFull', middle: 0.95}}
        footerContent={
          <BottomBar>
            <Button variant="primary" fullWidth onClick={handleClose}>
              <FormattedMessageWrapper
                id="srpFAQs.disclaimerAction"
                defaultMessage="Ok, got it"
              />
            </Button>
          </BottomBar>
        }
      >
        <Box
          paddingTop="s500"
          paddingBottom="s300"
          paddingLeft="s500"
          paddingRight="s500"
        >
          <Content />
        </Box>
      </BottomSheet>
    )
  }

  return (
    <PopUp
      noPaddings
      isOpen={isOpen}
      closeAction={handleClose}
      navBarProps={{
        centerContent: (
          <FormattedMessageWrapper
            id="srpFAQs.disclaimerTitle"
            defaultMessage="About these FAQs"
          />
        ),
        withDivider: true
      }}
    >
      <Box
        paddingBottom="s300"
        paddingTop="s500"
        paddingLeft="s500"
        paddingRight="s500"
      >
        <Content />
      </Box>
      <BottomBar>
        <Button variant="primary" fullWidth onClick={handleClose}>
          <FormattedMessageWrapper
            id="srpFAQs.disclaimerAction"
            defaultMessage="Ok, got it"
          />
        </Button>
      </BottomBar>
    </PopUp>
  )
}
